import { Popup } from '../../../../Managers/Popups';
import { ITweenable } from '../../ITweenable';
import { PopupHeader } from '../../PopupHeader';
import { ShareableOverlay } from './ShareableOverlay';
import { ScreenBlur } from '../../../Shared/ScreenBlur';
import { HudActions, HudEmitter } from '../../../../Managers/Hud/HudEmitter';
import { getGameSize } from '../../../../Config/Levels';
import { TweenMax } from 'gsap';
import { waitForMs } from '../../../../Utils/AsyncUtils';
import { ShareableMoments } from '../../../../SDK/SDKmessages';

export class ShareablePopup extends PIXI.Container implements ITweenable {
    protected overlay: ShareableOverlay;
    protected header: PopupHeader;
    protected screenFlash: PIXI.Sprite;

    constructor(
        headerKey: string,
        overlay: ShareableOverlay,
        type: ShareableMoments,
        flash: boolean = false
    ) {
        super();
        const bg = new ScreenBlur();
        bg.interactive = true;
        this.header = new PopupHeader(headerKey, Popup.SHAREABLE, 1.15, type);
        this.overlay = overlay;
        HudEmitter.instance.once(HudActions.SHARE_MOMENT_COMPLETE, () =>
            this.header.closeButton.emit('trigger')
        );
        //@ts-ignore
        this.addChild(bg, this.header, overlay);

        if (flash) {
            this.screenFlash = new PIXI.Sprite();
            const g = new PIXI.Graphics();
            g.beginFill(0xffffff);
            g.drawRect(0, 0, getGameSize().gameWidth, getGameSize().gameHeight);
            g.cacheAsBitmap = true;
            this.screenFlash.addChild(g);
            this.addChild(this.screenFlash);
        }
    }

    public async tweenIn(): Promise<void> {
        if (this.screenFlash) {
            this.screenFlash.alpha = 1;
            await waitForMs(300);
            TweenMax.to(this.screenFlash, 0.5, {
                alpha: 0,
                onComplete: () => {
                    const s = this.screenFlash;
                    this.screenFlash = null;
                    s.destroy();
                },
            });
            await waitForMs(400);
        }
        this.header.tweenIn();
        this.overlay.tweenIn();
    }

    public tweenOut(...args: any): any {
        if (this.screenFlash) {
            TweenMax.killTweensOf(this.screenFlash);
            this.screenFlash.destroy();
            this.screenFlash = null;
        }
        this.header.tweenOut();
        this.overlay.tweenOut();
    }
}
